// Vendor imports
const classNames = require('classnames')
const { connect } = require('react-redux')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const PromoBadge = require('client-v2/common/containers/promo-badge/component-smart')
const { usePropsCallback, usePropsEventCallback } = require('client-v2/common/hooks/callbacks')
const { useFullyVisibleViewportObserver } = require('client-v2/common/hooks/viewport-observer')

const bem = BemEntity('AppPromoCard')

function AppPromoCard(props) {
  // Hooks
  const blockRef = React.useRef()
  const onAndroidBadgeClick = useBadgeClickCallback(props, 'android')
  const onAppleBadgeClick = useBadgeClickCallback(props, 'ios')
  const onCardClick = usePropsEventCallback(props, 'onCardClick')
  const onFullyVisible = usePropsCallback(props, 'onFullyVisible')
  useFullyVisibleViewportObserver({
    elementRef: blockRef,
    onVisible: onFullyVisible
  })
  // Render
  return (
    tag('div', {
      ref: blockRef,
      className: classNames(
        props.className,
        bem.block({
          variant: props.variant
        })
      ),
      onClick: onCardClick
    },
      tag('div', {
        className: bem.element('inner')
      },
        // Header
        tag('div', {
          className: bem.element('header')
        },
          'Save and share',
          tag('br'),
          'from anywhere'
        ),
        // Badges
        tag('div', {
          className: bem.element('badges')
        },
          props.isAndroid && tag(PromoBadge, {
            className: bem.element('badge'),
            id: 'android',
            onClick: onAndroidBadgeClick
          }),
          props.isIos && tag(PromoBadge, {
            className: bem.element('badge'),
            id: 'ios',
            onClick: onAppleBadgeClick
          })
        ),
        // Device
        tag('div', {
          className: bem.element('device')
        })
      )
    )
  )
}

function useBadgeClickCallback(props, badgeId) {
  const { variant, onBadgeClick } = props
  return React.useCallback(
    event => {
      if (onBadgeClick) {
        event.stopPropagation()
        onBadgeClick({ variant, badge: badgeId })
      }
    },
    [ variant, badgeId, onBadgeClick ]
  )
}

const VARIANTS = [ 'a', 'b', 'c', 'd', 'e', 'f' ]

function getRandomVariant() {
  return VARIANTS[Math.floor(Math.random() * VARIANTS.length)]
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  AppPromoCard.propTypes = {
    // Flags
    isAndroid: PropTypes.bool,
    isIos: PropTypes.bool,
    // Values
    className: PropTypes.string,
    variant: PropTypes.oneOf(VARIANTS).isRequired,
    // Callbacks
    onBadgeClick: PropTypes.func,
    onCardClick: PropTypes.func,
    onFullyVisible: PropTypes.func
  }
}


function mapStateToProps(state) {
  return {
    isAndroid: !!state.env.browser.get('android'),
    isIos: !!state.env.browser.get('ios')
  }
}

module.exports = connect(
  mapStateToProps
)(
  Object.assign(AppPromoCard, {
    VARIANTS,
    getRandomVariant
  })
)
